import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  forwardRef,
} from "react";
import { toast } from "react-toastify";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";

import { useGlobalSpinnerActionsContext } from "../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../Context/LanguageContext";
import commonUtils from "../../helpers/commonUtils";
import reparaturStore from "../../Stores/ReparaturStore";
import ReparaturConstants from "../../Constants/ReparaturContstants";
import { useAMGSelectedContext } from "../../Context/GlobalContext";
import ReparaturActions from "../../Actions/ReparaturActions";

import DatePicker, { registerLocale, setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import es from "date-fns/locale/es";
import fr from "date-fns/locale/fr";
import de from "date-fns/locale/de";
import { IconButton, InputAdornment, TextField } from "@mui/material";

registerLocale("es", es);
registerLocale("fr", fr);
registerLocale("de", de);

var dateFormat = require("dateformat");

export default function AddMaintenance({
  anlageid,
  isOpen,
  setOpenAddMaintenance,
  addMaintenanceCallBack,
}) {
  var date = new Date(Date.now());
  const [open, setOpen] = React.useState(isOpen);
  const [fullWidth, setFullWidth] = React.useState(true);
  const [maxWidth, setMaxWidth] = React.useState("sm");
  const [startDate, setStartDate] = useState(date);
  const [selectBoxRender, setSelectBoxRender] = useState(null);
  const [rueckmeldungen, setrueckmeldungen] = useState([]);
  const [rueckmeldungenAsString, setRueckmeldungenAsString] = useState("");
  const [vorlagelist, setVorlagelist] = useState([]);
  const { localization } = useLanguageContext();
  const selectedAnlageG = useAMGSelectedContext();
  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  useEffect(() => {
    setGlobalSpinner(true);
    var _anlagegruppeid = sessionStorage.getItem("eqGId") || selectedAnlageG;

    if (_anlagegruppeid !== null && _anlagegruppeid !== undefined) {
      ReparaturActions.getRueckmeldungsvorlage(_anlagegruppeid);
    }

    return () => ({});
  }, []);

  const handelOnChangeTextarea = (event) => {
    var tmp = event.target.value;
    var _sr = rueckmeldungenAsString;

    setRueckmeldungenAsString(tmp);
  };

  const handelSelectChange = (event) => {
    const {
      target: { value },
    } = event;
    setrueckmeldungen(typeof value === "string" ? value.split(",") : value);
    setRueckmeldungenAsString(value.toString());
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    var _anlageid = sessionStorage.getItem("eqId") || anlageid;
    var _year = startDate.getFullYear;
    //var _date = startDate.toLocaleDateString(language.toLowerCase() + '-' + language.toUpperCase());
    var json_obj = {
      Reparaturen: rueckmeldungenAsString,
      anlageid: _anlageid,
      eintragDatum: dateFormat(startDate, "dd.mm.yyyy"), // [startDate.getFullYear(),startDate.getMonth(), startDate.getDate()].join('-'),
      userId: sessionStorage.getItem("userid"),
    };
    setGlobalSpinner(true);
    ReparaturActions.addReparatur(json_obj);
  };

  useEffect(() => {
    function getFeedbackTemplateSuccess() {
      var _details = reparaturStore.getResult();
      setVorlagelist(_details);
      setGlobalSpinner(false);
    }

    function getFeedbackTemplateError() {
      var _details = reparaturStore.getResult();
      setVorlagelist(_details);
      setGlobalSpinner(false);
    }

    reparaturStore.addChangeListener(
      ReparaturConstants.GET_RUECKMELDUNGVORLAGE_SUCCESS,
      getFeedbackTemplateSuccess
    );

    reparaturStore.addChangeListener(
      ReparaturConstants.GET_RUECKMELDUNGVORLAGE_FAILURE,
      getFeedbackTemplateError
    );

    return () => {
      reparaturStore.removeChangeListener(
        ReparaturConstants.GET_RUECKMELDUNGVORLAGE_SUCCESS,
        getFeedbackTemplateSuccess
      );

      reparaturStore.removeChangeListener(
        ReparaturConstants.GET_RUECKMELDUNGVORLAGE_FAILURE,
        getFeedbackTemplateError
      );
    };
  }, []);

  useEffect(() => {
    function addMaintenanceSuccess() {
      setRueckmeldungenAsString("");
      setrueckmeldungen([]);
      toast.success(true, true, localization.saveSuccess);
      addMaintenanceCallBack();
    }

    function addMaintenanceError() {
      const res = reparaturStore.getResult();
      setGlobalSpinner(false);
      toast.error(res);
    }

    reparaturStore.addChangeListener(
      ReparaturConstants.ADD_REPARATUR_SUCCESS,
      addMaintenanceSuccess
    );

    reparaturStore.addChangeListener(
      ReparaturConstants.ADD_REPARATUR_FAILURE,
      addMaintenanceError
    );

    return () => {
      reparaturStore.removeChangeListener(
        ReparaturConstants.ADD_REPARATUR_SUCCESS,
        addMaintenanceSuccess
      );

      reparaturStore.removeChangeListener(
        ReparaturConstants.ADD_REPARATUR_FAILURE,
        addMaintenanceError
      );
    };
  }, []);

  const handleClose = () => {
    setOpen(false);
    setOpenAddMaintenance(false);
  };

  let disabled =
    sessionStorage.getItem("isReaderOnly") === "true" ? "true" : "";

  const CustomInput = forwardRef(({ value, onClick }, ref) => (
    <div onClick={onClick} ref={ref}>
      <FormControl variant="outlined" className="w-100">
        <InputLabel htmlFor="selectDate">{localization.date}</InputLabel>
        <OutlinedInput
          id="selectDate"
          type="text"
          value={value}
          endAdornment={
            <InputAdornment position="end">
              <IconButton aria-label="select date" edge="end">
                <CalendarTodayOutlinedIcon
                  style={{ marginLeft: "8px", color: "#555" }}
                />
              </IconButton>
            </InputAdornment>
          }
          label={localization.date}
        />
      </FormControl>
    </div>
  ));

  return (
    <React.Fragment>
      <Dialog
        fullWidth={fullWidth}
        maxWidth={maxWidth}
        open={open}
        onClose={handleClose}
      >
        <form onSubmit={handleSubmit}>
          <DialogTitle>{localization.addMaintenance}</DialogTitle>
          <DialogContent>
            <DialogContentText style={{ fontSize: "14px" }}>
              {localization.scheduleNewMaintenance}
            </DialogContentText>
            <div className="maintenanceFormFieldContainer mt-3">
              <FormControl className="w-100">
                <InputLabel id="selectTextModules">
                  {localization.selectOption}
                </InputLabel>
                <Select
                  labelId="selectTextModules"
                  id="selectTextModules-checkbox"
                  multiple
                  fullWidth
                  value={rueckmeldungen}
                  onChange={handelSelectChange}
                  input={<OutlinedInput label="selectTextModules" />}
                  renderValue={(selected) => selected.join(", ")}
                  MenuProps={MenuProps}
                >
                  {vorlagelist.map((item, index) => (
                    <MenuItem key={item.id} value={item.bezeichnung}>
                      <Checkbox
                        checked={rueckmeldungen.indexOf(item.bezeichnung) > -1}
                      />
                      <ListItemText primary={item.bezeichnung} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <div className="w-100">
                <div className="form-group">
                  <div className="control-label ">
                    <DatePicker
                      dateFormat="dd.MM.yyyy"
                      disabled={disabled}
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      className="form-control"
                      customInput={<CustomInput />}
                    />
                  </div>
                </div>
              </div>
              <div className="w-100">
                <TextField
                  id="maintenanceDesc"
                  fullWidth
                  label="Description"
                  multiline
                  rows={4}
                  placeholder={localization.reparaturboxPlaceholder}
                  value={rueckmeldungenAsString}
                  required
                  onChange={handelOnChangeTextarea}
                />
              </div>
            </div>
          </DialogContent>
          <DialogActions>
            <Button
              variant="outlined"
              sx={{ textTransform: "none" }}
              size="large"
              onClick={handleClose}
            >
              {localization.cancelbutton}
            </Button>
            {!commonUtils.isReader() && (
              <div className="form-group">
                <Button
                  type="submit"
                  variant="contained"
                  className="containedBtnCls"
                  sx={{ textTransform: "none" }}
                  size="large"
                >
                  {localization.addMaintenance}
                </Button>
              </div>
            )}
          </DialogActions>
        </form>
      </Dialog>
    </React.Fragment>
  );
}
